import { useState } from "react";
import { LdsButton, LdsModal } from "@elilillyco/ux-lds-react";
import moment from "moment";

/**
 * Confirmation modal for Admin/Super Admin "Undo Archive" on an expiration-archived list.
 *
 * The expiration date field is pre-filled with 30 days from today, giving
 * marketers enough time to create a new list from the un-archived list and
 * get it approved. The date can be overridden by the admin if needed.
 */
const UndoArchiveConfirmationModal = ({ open, setModalOpen, undoArchive }) => {
  const today = moment().format("YYYY-MM-DD");
  const defaultExpDate = moment().add(30, "days").format("YYYY-MM-DD");
  const [newExpirationDate, setNewExpirationDate] = useState(defaultExpDate);
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await undoArchive(newExpirationDate || null);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <LdsModal
      modalId="UndoArchiveConfirmationModal"
      className="text-center"
      size="col-12 col-sm-8 col-md-8 col-lg-8"
      open={open}
      setModalOpen={setModalOpen}
    >
      <div>
        <h2>Undo Archive</h2>
        <p className="mt-4">
          This list was automatically archived because it expired. Restoring
          it will set the status back to <b>APPROVED</b> and make it active
          again.
        </p>
        <p className="mt-2">
          The new expiration date is set to <b>30 days from today</b> by default,
          giving marketers enough time to create a new list and get it approved.
          You can adjust the date below if needed.
        </p>

        <div className="row mt-4" style={{ justifyContent: "center" }}>
          <div className="col col-12 col-md-6">
            <label htmlFor="undo-archive-exp-date" className="mr-2">
              New Expiration Date
            </label>
            <input
              id="undo-archive-exp-date"
              type="date"
              min={today}
              value={newExpirationDate}
              onChange={(e) => setNewExpirationDate(e.target.value)}
              style={{ padding: "0.5rem", width: "100%" }}
            />
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col">
          <div className="floatRight">
            <LdsButton
              classes="button-icon-right blue-bdr-btn"
              onClick={() => setModalOpen(false)}
              disabled={submitting}
            >
              Cancel
            </LdsButton>
            <LdsButton
              classes="button-icon-right blue-btn ml-4 mt-4"
              type="submit"
              onClick={handleConfirm}
              disabled={submitting}
            >
              {submitting ? "Restoring..." : "Confirm Undo Archive"}
            </LdsButton>
          </div>
        </div>
      </div>
    </LdsModal>
  );
};

export default UndoArchiveConfirmationModal;
